import { useEffect } from 'react';
const createMutableList = () => {
    const list = new Array();
    const getIndex = (id) => {
        const index = list.findIndex((item) => item.id === id);
        return index === -1 ? null : index;
    };
    return {
        update: (item) => {
            const index = getIndex(item.id) ?? list.length;
            list[index] = item;
        },
        delete: (itemId) => {
            const index = getIndex(itemId);
            if (index)
                list.splice(index, 1);
        },
        unwrap: () => list,
        clear: () => (list.length = 0),
    };
};
export function useIntersectedItems(onIntersectionCb, intersectionObserverSettings, sections) {
    useEffect(() => {
        const intersectedItems = createMutableList();
        const sectionsArray = Array.from(sections.values());
        const observer = new IntersectionObserver((entries) => {
            const elementToId = new Map(sectionsArray.map(({ id, ref }) => [ref.current, id]));
            entries.forEach((entry) => {
                const elementId = elementToId.get(entry.target);
                if (!elementId)
                    return; // Skip if not found in our registered sections
                if (entry.isIntersecting) {
                    const intersectingItem = {
                        id: elementId,
                        intersectionRatio: entry.intersectionRatio,
                        target: entry.target,
                    };
                    intersectedItems.update(intersectingItem);
                }
                else {
                    intersectedItems.delete(elementId);
                }
            });
            onIntersectionCb(intersectedItems.unwrap());
        }, intersectionObserverSettings);
        sectionsArray.forEach(({ ref: { current: element } }) => {
            if (element)
                observer.observe(element);
        });
        return () => {
            observer.disconnect();
            intersectedItems.clear();
        };
    }, [intersectionObserverSettings, sections, onIntersectionCb]);
}
